import { Grid, Link, Theme, useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
const BackArrow = ({ color }: { color: string }) => (
  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 0L9.70323 1.70323L3.40645 8L9.65161 14.2452L7.94839 16L0 8L8 0Z" fill={color} />
  </svg>
);

export default function CallToAction(props: any) {
  const theme: Theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const disabledStyles = theme.custom.styles.ctaNextButton['&.Mui-disabled'] || {};
  const inlineDisabledStyle = props.nextButtonDisabled
    ? {
        backgroundColor: disabledStyles.backgroundColor,
        color: disabledStyles.color,
        boxShadow: disabledStyles.boxShadow,
        border: disabledStyles.border,
        borderColor: disabledStyles.borderColor,
      }
    : {};

  return (
    <Box sx={{ width: '100%', display: 'flex' }}>
      <Grid container>
        <Grid item xs={12}>
          <Box
            component="hr"
            sx={{
              border: { xs: 'none', sm: theme.custom.styles.ctaHrStyle },
              width: '100%',
              marginTop: '2rem',
              marginBottom: '1.5em',
            }}
          />
        </Grid>

        <Grid container sx={{ display: 'flex' }} item xs={12}>
          {props.nextButton && (
            <Button
              type="submit"
              disabled={props.nextButtonDisabled}
              onClick={props.handleNext}
              style={inlineDisabledStyle}
              sx={{
                ...theme.custom.styles.ctaNextButton,
                '&.MuiButtonBase-root:hover': {
                  bgcolor: isMobile ? theme.custom.colors.secondaryColor : theme.custom.colors.primaryButtonHoverColor,
                },
              }}
            >
              {props.nextButtonContent}
            </Button>
          )}
          {props.cancelButton && (
            <Button onClick={props.handleCancel} sx={theme.custom.styles.ctaCancelButton}>
              {props.cancelButtonContent}
            </Button>
          )}
          {props.backButton &&
            ((!isMobile && !theme.custom.styles.ctaBackButtonIsLinkOnDesktop) ||
            (isMobile && !theme.custom.styles.ctaBackButtonIsLinkOnMobile) ? (
              <Button variant="outlined" onClick={props.handleBack} sx={theme.custom.styles.ctaBackButton}>
                {props.backButtonContent}
              </Button>
            ) : (
              <Link
                onClick={props.handleBack}
                sx={{
                  ...theme.custom.styles.ctaBackButton,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '.5rem',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  fontFamily: theme.custom.styles.primaryDescription.fontFamily,
                }}
              >
                <BackArrow color={theme.custom.styles.ctaBackButton.color} />
                {props.backButtonContent}
              </Link>
            ))}
          {props.skipButton && (
            <Button onClick={props.handleSkip} sx={theme.custom.styles.ctaSkipButton} variant="outlined">
              {props.skipButtonContent}
            </Button>
          )}
          <Box sx={theme.custom.styles.ctaFlexSpace}></Box>
        </Grid>
      </Grid>
    </Box>
  );
}
